<div class="PageContent">
 
  <div class="overlay" *ngIf="ShowAddNewPartnerForm || ShowGeneratePartnersSearchResultsPopUp || ShowShipmentRequestPopup;"></div>
  <div class="overlayTransparent animated fadeIn" *ngIf="ShowFilter == true;" (click)="CloseOverlay();"></div>

  <div class="EditContainer ShipmentRequestPopUp animated fadeInDown" *ngIf="this.ShowShipmentRequestPopup == true;">
    <div class="EditContainerCloseButton" (click)="this.ShowShipmentRequestPopup = false;">
      <i class="material-icons">close</i>
    </div>
    <div class="EditContainerHeadder">
      <p class="EditContainerHeadderTitle">
        <span class="EditContainerReferenceNumber">{{'SendShipmentRequestPreparation' | translate}}</span>
      </p>
    </div>
    <div class="EditContainerBody" style="height: Calc(100% - 150px);padding-top: 20px;">
      <div class="ButtonsSubContainerCommands" *ngIf="this.parent.loading != true;">
        <div class="ButtonsSubContainerCell">
          <mat-form-field class="ReceptionProductsColDropDown" appearance="outline" style="width: auto; margin-left: 2.5%;float: left;">
            <mat-label>{{ 'ShippingResponsability' | translate }}</mat-label>
            <mat-select name="ShippingResponsability" [(ngModel)]="this.ShippingDetails.ShippingResponsability" [disabled]="this.parent.loading">
              <mat-option *ngFor="let s of this.ShippingResponsabilities;" [value]="s">
                {{s.Name}} ({{s.Description}})
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
  
        <div class="ButtonsSubContainerCell">
          <mat-form-field class="ReceptionProductsColDropDown" appearance="outline" style="width: auto; margin-left: 2.5%;float: left;">
            <mat-label>{{ 'ShippingCompany' | translate }}</mat-label>
            <mat-select name="ShippingServiceType" [(ngModel)]="this.ShippingDetails.ShippingCompany" [disabled]="this.parent.loading || this.ShippingDetails?.ShippingResponsability?.ID !== 1">
              <mat-option *ngFor="let s of this.ShippingCompanies;" [value]="s">
                <span>{{s.Name}}</span>
                <img class="ShippingCompanyImage" *ngIf="s.ImagePath?.length > 0;" [src]="this.parent.BackendServiceUrl + s.ImagePath" />
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
  
        <div class="ButtonsSubContainerCell">
          <mat-form-field class="ReceptionProductsColDropDown" appearance="outline" style="width: auto; margin-left: 2.5%;float: left;">
            <mat-label>{{ 'ShippingServiceType' | translate }}</mat-label>
            <mat-select name="ShippingServiceType" [(ngModel)]="this.ShippingDetails.ShippingServiceType" [disabled]="this.parent.loading || this.ShippingDetails?.ShippingResponsability?.ID !== 1">
              <mat-option *ngFor="let s of this.ShippingServiceTypes;" [value]="s">
                {{s.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
  
      <div class="EmailReceipientsContainer">
          <p>{{'CCEmailCopy' | translate}}</p>
          <div class="EmailAgent" *ngFor="let a of this.PartnerAgents;" (click)="a.IsSelected = !a.IsSelected;" [ngClass]="{'selectedAgent': a.IsSelected == true}">
              <i class="material-icons" *ngIf="a.IsSelected" style="color: #32aa3a;">check</i>
              <i class="material-icons" *ngIf="!a.IsSelected" style="color: #fd4f57;">close</i>
              <span>{{a.Email}}</span>
          </div>
      </div>
  
        <mat-form-field appearance="outline" class="ClientMessageText">
          <mat-label>{{ 'YouMessageForOurTeam' | translate }}</mat-label>
          <textarea autocomplete="off" matInput
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="5"
                    cdkAutosizeMaxRows="5"
                    [(ngModel)]="ClientMessage"></textarea>
        </mat-form-field>
  
        <p class="FinalDispatchInformation">
          <i class="material-icons">info_outline</i>
          <span *ngIf="this.ShippingDetails?.ShippingResponsability?.ID == 0">{{'ShipmentEXW' | translate}}</span>
          <span *ngIf="this.ShippingDetails?.ShippingResponsability?.ID == 1">
            {{'ShipmentDAP' | translate}}
            <span>({{this.ShippingDetails?.ShippingServiceType?.Name}})</span>
            <span class="NewLine">{{'ShippingCompany' | translate}} ({{this.ShippingDetails?.ShippingCompany?.Name}})</span>
          </span>
        </p>
    </div>
  
    <div class="EditContainerControlls" style="height: 90px;">
      <button (click)="SendDispatchEmailClientRequest();" [disabled]="this.parent.loading" class="SendShipmentRequestPopUpButton" mat-raised-button style="background-color: #32aa3a;" color="primary" *ngIf="this.ShippingDetails.ShippingServiceType">
        <i class="material-icons">check</i>
        <span style="margin-left: 10px;">{{'SendRequest' | translate}}</span>
      </button>
    </div>
  </div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowGeneratePartnersSearchResultsPopUp">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowGeneratePartnersSearchResultsPopUp = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'GeneratePartnersSearchResults' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'GeneratePartnersSearchResultsDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowGeneratePartnersSearchResultsPopUp = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ShowGeneratePartnersSearchResultsPopUp = false; GeneratePartnersSearchResults();">{{ 'GeneratePartnersSearchResults' | translate }}</button>
    </div>
  </div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteProfitMessage">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowDeleteProfitMessage = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'Configuration.DeleteQuestion' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'Configuration.DeleteQuestionDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteProfitMessage = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteProfitMessage = false; DeleteProfitSettings();">{{ 'Configuration.DeleteYesButton' | translate }}</button>
    </div>
  </div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteRestrictionQuestion">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowDeleteRestrictionQuestion = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'Configuration.DeleteQuestion' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'Configuration.DeleteQuestionDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteRestrictionQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteRestrictionQuestion = false; DeletePartnerB2BRestriction(this.DeletingRestriction);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
    </div>
  </div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteYearSettingsQuestion">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowDeleteYearSettingsQuestion = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'Configuration.DeleteQuestion' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'Configuration.DeleteQuestionDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteYearSettingsQuestion = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteYearSettingsQuestion = false; DeletePartnersB2BHistoryYearSettings(this.CurrentYearSettings);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
    </div>
  </div>

  <div class="NewProfitSettingsContainer animated fadeInDown" *ngIf="ShowNewProfitSettings == true;">
    <div class="NewProfitSettingsContainerTitle">{{'AddNewProfitSettings' | translate}}</div>
    <div class="NewProfitSettingsContainerClose" (click)="this.ShowNewProfitSettings = false;">
      <i class="material-icons">close</i>
    </div>

    <div class="NewProfitSettingsContainerBody">

      <div class="NewProfitSettingsContainerBodyRow">
        <mat-form-field appearance="outline" class="BrandSelectContainer" style="margin-left: 5%;">
          <mat-label>{{ 'Client' | translate }}*</mat-label>
          <input disabled="true" matInput placeholder="{{ 'Client' | translate }}*" autocomplete="off" class="BrandSelect" [(ngModel)]="this.ProfitSettings.PartnerName">
        </mat-form-field>
       </div>

       <div class="NewProfitSettingsContainerBodyRow" *ngIf="this.ProfitSettings?.PercentageImpact?.PercentageProfitMargin != null">
        <mat-form-field appearance="outline" class="BrandSelectContainer" style="margin-left: 5%;">
          <mat-label>% {{ 'OurProfit' | translate }}*</mat-label>
          <input disabled="true" matInput placeholder="{{ 'OurProfit' | translate }}*" autocomplete="off" class="BrandSelect" [(ngModel)]="this.ProfitSettings.PercentageImpact.PercentageProfitMargin">
        </mat-form-field>
       </div>

       <div class="NewProfitSettingsContainerBodyRow">
        <mat-form-field class="BrandSelectContainer" appearance="outline" style="margin-left: 5%;">
          <mat-label>{{'SearchConfiguration' | translate}}*</mat-label>
          <input class="BrandSelect"
                 type="text"
                 placeholder="{{'SearchConfiguration' | translate}}"
                 matInput
                 (click)="InitializeImportConfigurations();"
                 [matAutocomplete]="auto3"
                 [(ngModel)]="this.ConfigurationTerm"
                 (ngModelChange)="this.configSearchTermUpdate.next($event)">
          <i style="height: 25px; line-height:25px;" class="material-icons BrandSelectCloseIcon">search</i>
          <mat-autocomplete #auto3="matAutocomplete">
            <mat-option *ngFor="let c of ImportConfigurations" [value]="Configuration" (click)="SelectConfiguration(c);">
              {{c.Name}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
       </div>

       <div class="NewProfitSettingsContainerBodyRow" *ngIf="this.ProfitSettings?.ImportConfiguration?.DiscountedGroups?.length > 0;">
        <mat-form-field appearance="outline"class="ProductPropertyTextBox" style="margin-left: 5%;">
          <mat-label>{{ 'SearchGroup' | translate }}</mat-label>
          <mat-select name="SearchGroup" [compareWith]="this.parent.compareFn" [(ngModel)]="this.ProfitSettings.DiscountGroup">
            <mat-option *ngFor="let g of this.ProfitSettings?.ImportConfiguration?.DiscountedGroups" [value]="g">
              {{g.GroupName}} ({{g.DiscountValue}}% {{'PurchaseDiscount' | translate}})
            </mat-option>
          </mat-select>
        </mat-form-field>
       </div>

     <div class="NewProfitSettingsContainerBodyRow">
      <mat-form-field class="BrandSelectContainer" appearance="outline" style="margin-left: 5%;">
        <mat-label>{{'SelectBrand' | translate}}</mat-label>
        <input class="BrandSelect"
               type="text"
               placeholder="{{'SelectBrand' | translate}}"
               matInput
               [matAutocomplete]="auto1"
               [(ngModel)]="this.BrandSearchTerm"
               (ngModelChange)="this.brandSearchTermUpdate.next($event)"
               (click)="InitializeBrands();">
        <i class="material-icons BrandSelectCloseIcon" *ngIf="this.BrandSearchTerm?.length > 0;" (click)="ClearSearchBrand();">close</i>
        <i class="material-icons BrandSelectCloseIcon" *ngIf="(this.BrandSearchTerm?.length > 0) != true;">search</i>
        <mat-autocomplete #auto1="matAutocomplete">
          <mat-option *ngFor="let brand of Brands" [value]="brand" (click)="this.Brand = brand; this.BrandSearchTerm = brand.Name; this.ProfitSettings.Brand = brand;">
            {{brand.Name}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
     </div>

     <div class="NewProfitSettingsContainerBodyRow">
      <mat-form-field appearance="outline"class="ProductPropertyTextBox" style="margin-left: 5%;" matTooltip="{{this.ProfitSettings?.PercentageImpact?.Description}}" matTooltipClass='neutral-tool-tip-management'>
        <mat-label>{{ 'ProfitSettingsPercentageImpact' | translate }}</mat-label>
        <mat-select name="ProfitSettingsPercentageImpact" [compareWith]="this.parent.compareFn" [(ngModel)]="this.ProfitSettings.PercentageImpact">
          <mat-option *ngFor="let p of this.ProfitSettingsPercentageImpacts" [value]="p">
            {{p.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
     </div>

     <div class="NewProfitSettingsContainerBodyRow">
      <mat-form-field appearance="outline" class="BrandSelectContainer" style="margin-left: 5%;">
        <mat-label *ngIf="this.ProfitSettings?.PercentageImpact?.ID == 0;">{{ 'PriceListDiscountClient' | translate }}*</mat-label>
        <mat-label *ngIf="this.ProfitSettings?.PercentageImpact?.ID == 1;">{{ 'PureProfitFromPurchasePrice' | translate }}*</mat-label>
        <input matInput placeholder="{{ 'Percentage' | translate }}*" autocomplete="off" class="BrandSelect" [(ngModel)]="this.ProfitSettings.Percentage">
      </mat-form-field>
     </div>

     <div class="NewProfitSettingsContainerBodyRow">
      <mat-form-field appearance="outline" class="BrandSelectContainer" style="margin-left: 5%;">
        <mat-label>{{ 'ExtraAddedValue' | translate }}*</mat-label>
        <input matInput placeholder="{{ 'ExtraAddedValue' | translate }}*" autocomplete="off" class="BrandSelect" [(ngModel)]="this.ProfitSettings.ExtraAddedValue">
      </mat-form-field>
     </div>

     <div class="NewProfitSettingsContainerBodyRow">
      <mat-form-field appearance="outline" class="BrandSelectContainer" style="margin-left: 5%;">
        <mat-label>{{ 'ExtraAddedPercentageValue' | translate }}*</mat-label>
        <input matInput placeholder="{{ 'ExtraAddedPercentageValue' | translate }}*" autocomplete="off" class="BrandSelect" [(ngModel)]="this.ProfitSettings.ExtraAddedPercentageValue">
      </mat-form-field>
     </div>
    </div>

    <div class="NewProfitSettingsContainerCommands">
      <button mat-raised-button color="primary" class="SaveProfitSettingsButton" (click)="AddUpdatePartnerProfitSettings();">
        <span>{{'SaveButton' | translate}}</span>
        <i class="material-icons">save_alt</i>
      </button>

      <button mat-raised-button color="warn" style="background: #fd4f57;" class="SaveProfitSettingsButton" (click)="this.ShowDeleteProfitMessage = true;">
        <span>{{'Delete' | translate}}</span>
        <i class="material-icons">close</i>
      </button>
    </div>
  </div>

  <div class="NewProfitSettingsContainer animated fadeInDown" *ngIf="ShowNewRestrictionSettings == true;">
    <div class="NewProfitSettingsContainerTitle">{{'AddNewRestrictionSettings' | translate}}</div>
    <div class="NewProfitSettingsContainerClose" (click)="this.ShowNewRestrictionSettings = false;">
      <i class="material-icons">close</i>
    </div>

    <div class="NewProfitSettingsContainerBody">

      <div class="NewProfitSettingsContainerBodyRow">
        <mat-form-field appearance="outline" class="BrandSelectContainer" style="margin-left: 5%;">
          <mat-label>{{ 'Client' | translate }}*</mat-label>
          <input disabled="true" matInput placeholder="{{ 'Client' | translate }}*" autocomplete="off" class="BrandSelect" [(ngModel)]="this.Partner.Name">
        </mat-form-field>
       </div>

       <div class="NewProfitSettingsContainerBodyRow">
        <mat-form-field appearance="outline"class="ProductPropertyTextBox" style="margin-left: 5%;">
          <mat-label>{{ 'RestrictionType' | translate }}</mat-label>
          <mat-select name="SearchGroup" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Restriction.Type">
            <mat-option *ngFor="let t of this.RestrictionTypes" [value]="t" (click)="SelectRestrictionType(t);">
              {{t.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
       </div>
     
       <div class="NewProfitSettingsContainerBodyRow">
        <mat-form-field class="BrandSelectContainer" appearance="outline" style="margin-left: 5%;">
          <mat-label>{{'SearchConfiguration' | translate}}*</mat-label>
          <input class="BrandSelect"
                 type="text"
                 placeholder="{{'SearchConfiguration' | translate}}"
                 matInput
                 (click)="InitializeImportConfigurations();"
                 [matAutocomplete]="auto3"
                 [(ngModel)]="this.ConfigurationTerm"
                 (ngModelChange)="this.configSearchTermUpdate.next($event)"
                 [disabled]="this.Restriction?.Type?.ID != -1">
          <i style="height: 25px; line-height:25px;" class="material-icons BrandSelectCloseIcon" *ngIf="!(this.ConfigurationTerm?.length > 0);">search</i>
          <i class="material-icons BrandSelectCloseIcon" *ngIf="this.ConfigurationTerm?.length > 0;" (click)="ClearRestrictionConfiguration();">close</i>
          <mat-autocomplete #auto3="matAutocomplete">
            <mat-option *ngFor="let c of ImportConfigurations" [value]="Configuration" (click)="SelectRestrictionConfiguration(c);">
              {{c.Name}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
       </div>

     <div class="NewProfitSettingsContainerBodyRow">
      <mat-form-field class="BrandSelectContainer" appearance="outline" style="margin-left: 5%;">
        <mat-label>{{'SelectBrand' | translate}}</mat-label>
        <input class="BrandSelect"
               type="text"
               placeholder="{{'SelectBrand' | translate}}"
               matInput
               [matAutocomplete]="auto1"
               [(ngModel)]="this.BrandSearchTerm"
               (ngModelChange)="this.brandSearchTermUpdate.next($event)"
               (click)="InitializeBrands();"
               [disabled]="this.Restriction?.Type?.ID != 1">
        <i class="material-icons BrandSelectCloseIcon" *ngIf="this.BrandSearchTerm?.length > 0;" (click)="ClearSearchBrand();">close</i>
        <i class="material-icons BrandSelectCloseIcon" *ngIf="(this.BrandSearchTerm?.length > 0) != true;">search</i>
        <mat-autocomplete #auto1="matAutocomplete">
          <mat-option *ngFor="let brand of Brands" [value]="brand" (click)="this.Brand = brand; this.BrandSearchTerm = brand.Name; this.Restriction.RestrictedBrand = brand;">
            {{brand.Name}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
     </div>

     <div class="NewProfitSettingsContainerBodyRow">
      <mat-form-field class="BrandSelectContainer" appearance="outline" style="margin-left: 5%;">
        <mat-label>{{'SelectCountry' | translate}}</mat-label>
        <input class="BrandSelect"
               type="text"
               placeholder="{{'SelectCountry' | translate}}"
               matInput
               [matAutocomplete]="auto4"
               [(ngModel)]="this.CountrySearchTerm"
               (ngModelChange)="this.countrySearchTermUpdate.next($event)"
               (click)="InitializeCountries();"
               [disabled]="this.Restriction?.Type?.ID != 2">
        <i class="material-icons BrandSelectCloseIcon" *ngIf="this.CountrySearchTerm?.length > 0;" (click)="ClearSearchCountry();">close</i>
        <i class="material-icons BrandSelectCloseIcon" *ngIf="(this.CountrySearchTerm?.length > 0) != true;">search</i>
        <mat-autocomplete #auto4="matAutocomplete">
          <mat-option *ngFor="let c of SpareCountries" [value]="c" (click)="SelectRestrictionCountry(c);">
            {{c.Name}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
     </div>
    </div>

    <div class="NewProfitSettingsContainerCommands">
      <button mat-raised-button color="primary" class="SaveProfitSettingsButton" (click)="AddUpdatePartnerB2BRestriction();">
        <span>{{'SaveButton' | translate}}</span>
        <i class="material-icons">save_alt</i>
      </button>

      <button mat-raised-button color="warn" style="background: #fd4f57;" class="SaveProfitSettingsButton" (click)="this.ShowNewRestrictionSettings = true;">
        <span>{{'Delete' | translate}}</span>
        <i class="material-icons">close</i>
      </button>
    </div>
  </div>

  <div class="NewProfitSettingsContainer animated fadeInDown" style="height: 40vh;" *ngIf="ShowNewYearSettingsBrandChange == true;">
    <div class="NewProfitSettingsContainerTitle">{{'ChooseBrand' | translate}}</div>
    <div class="NewProfitSettingsContainerClose" (click)="this.ShowNewYearSettingsBrandChange = false;">
      <i class="material-icons">close</i>
    </div>

    <div class="NewProfitSettingsContainerBody">

     <div class="NewProfitSettingsContainerBodyRow">
      <mat-form-field class="BrandSelectContainer" appearance="outline" style="margin-left: 5%;">
        <mat-label>{{'SelectBrand' | translate}}</mat-label>
        <input class="BrandSelect"
               type="text"
               placeholder="{{'SelectBrand' | translate}}"
               matInput
               [matAutocomplete]="auto1"
               [(ngModel)]="this.BrandSearchTerm"
               (ngModelChange)="this.brandSearchTermUpdateForNewYearSettings.next($event)"
               (click)="InitializeBrands();">
        <i class="material-icons BrandSelectCloseIcon" *ngIf="this.BrandSearchTerm?.length > 0;" (click)="ClearSearchBrand();">close</i>
        <i class="material-icons BrandSelectCloseIcon" *ngIf="(this.BrandSearchTerm?.length > 0) != true;">search</i>
        <mat-autocomplete #auto1="matAutocomplete">
          <mat-option *ngFor="let brand of Brands" [value]="brand" (click)="this.Brand = brand; this.BrandSearchTerm = brand.Name; SelectBrandForNewYearsSetting(brand);">
            {{brand.Name}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
     </div>
   
    </div>

    <div class="NewProfitSettingsContainerCommands">
      <button mat-raised-button color="primary" class="SaveProfitSettingsButton" (click)="this.ShowNewYearSettingsBrandChange = false;">
        <span>{{'SaveButton' | translate}}</span>
        <i class="material-icons">save_alt</i>
      </button>
    </div>
  </div>

  <div class="NewProfitSettingsContainer animated fadeInDown" style="height: 40vh;" *ngIf="ShowYearSettingsBrandChange == true;">
    <div class="NewProfitSettingsContainerTitle">{{'ChooseBrand' | translate}}</div>
    <div class="NewProfitSettingsContainerClose" (click)="this.ShowYearSettingsBrandChange = false;">
      <i class="material-icons">close</i>
    </div>

    <div class="NewProfitSettingsContainerBody">

     <div class="NewProfitSettingsContainerBodyRow">
      <mat-form-field class="BrandSelectContainer" appearance="outline" style="margin-left: 5%;">
        <mat-label>{{'SelectBrand' | translate}}</mat-label>
        <input class="BrandSelect"
               type="text"
               placeholder="{{'SelectBrand' | translate}}"
               matInput
               [matAutocomplete]="auto1"
               [(ngModel)]="this.BrandSearchTerm"
               (ngModelChange)="this.brandSearchTermUpdateForYearSettings.next($event)"
               (click)="InitializeBrands();">
        <i class="material-icons BrandSelectCloseIcon" *ngIf="this.BrandSearchTerm?.length > 0;" (click)="ClearSearchBrand();">close</i>
        <i class="material-icons BrandSelectCloseIcon" *ngIf="(this.BrandSearchTerm?.length > 0) != true;">search</i>
        <mat-autocomplete #auto1="matAutocomplete">
          <mat-option *ngFor="let brand of Brands" [value]="brand" (click)="this.Brand = brand; this.BrandSearchTerm = brand.Name; SelectBrandForYearsSetting(brand);">
            {{brand.Name}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
     </div>
   
    </div>

    <div class="NewProfitSettingsContainerCommands">
      <button mat-raised-button color="primary" class="SaveProfitSettingsButton" (click)="this.ShowYearSettingsBrandChange = false;">
        <span>{{'SaveButton' | translate}}</span>
        <i class="material-icons">save_alt</i>
      </button>
    </div>
  </div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowPartnerAgentDeleteMessage">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowPartnerAgentDeleteMessage = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'Configuration.DeleteQuestion' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'Configuration.DeleteQuestionDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowPartnerAgentDeleteMessage = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowPartnerAgentDeleteMessage = false; DeletePartnerAgent(this.PartnerAgent.ID);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
    </div>
  </div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowPartnerAddressDeleteMessage">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowPartnerAddressDeleteMessage = false;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'Configuration.DeleteQuestion' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'Configuration.DeleteQuestionDescription' | translate }}
    </div>

    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowPartnerAddressDeleteMessage = false;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowPartnerAddressDeleteMessage = false; DeletePartnerShippingAddress(this.CurrentShippingAddress);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
    </div>
  </div>

  <div class="NewProductContainer animated fadeInDown" *ngIf="ShowAddNewPartnerForm == true;">
    <div class="NewProductContainerTitleBar">
      <p *ngIf="this.Partner.ID ==  null;">{{'AddNewPartner' | translate}}</p>
      <p *ngIf="this.Partner.ID?.length > 0;">{{'ModifyPartner' | translate}}: {{this.Partner.Name}} ({{this.Partner.Code}})</p>
      <i class="material-icons" (click)="ShowAddNewPartnerForm = false;">close</i>
    </div>
    <div class="NewProductContainerBody">
     
      <div class="SMTPEmailContainer" (click)="ShowB2BRestrictions = false; ShowBillingInfo = true; ShowShippingInfo = false; ShowAgentsInfo = false; ShowProcessingSettings = false; ShowProfitSettings = false;">
        <span>{{'ViewBillingInformation' | translate}}</span>
        <i class="material-icons" *ngIf="ShowBillingInfo == true;">radio_button_checked</i>
        <i class="material-icons" *ngIf="ShowBillingInfo == false;" style="color: #000;">radio_button_off</i>
      </div>

      <div class="SMTPEmailContainer" (click)="ShowB2BRestrictions = false; ShowShippingInfo = true; ShowBillingInfo = false; ShowAgentsInfo = false; ShowProcessingSettings = false; ShowProfitSettings = false;">
        <span>{{'ViewShippingInformation' | translate}}</span>
        <i class="material-icons" *ngIf="ShowShippingInfo == true;">radio_button_checked</i>
        <i class="material-icons" *ngIf="ShowShippingInfo == false;" style="color: #000;">radio_button_off</i>
      </div>

      <div class="SMTPEmailContainer" (click)="ShowB2BRestrictions = false; ShowShippingInfo = false; ShowBillingInfo = false; ShowAgentsInfo = true; ShowProcessingSettings = false; GetPartnerAgents(this.Partner.ID); ShowProfitSettings = false;">
        <span>{{'ViewAgentsInformation' | translate}}</span>
        <i class="material-icons" *ngIf="ShowAgentsInfo == true;">radio_button_checked</i>
        <i class="material-icons" *ngIf="ShowAgentsInfo == false;" style="color: #000;">radio_button_off</i>
      </div>

      <div class="SMTPEmailContainer" (click)="ShowB2BRestrictions = false; ShowShippingInfo = false; ShowBillingInfo = false; ShowAgentsInfo = false; ShowProcessingSettings = false; ShowProfitSettings = true;GetPartnerProfitSettings();">
        <span>{{'ViewProfitSettings' | translate}}</span>
        <i class="material-icons" *ngIf="ShowProfitSettings == true;">radio_button_checked</i>
        <i class="material-icons" *ngIf="ShowProfitSettings == false;" style="color: #000;">radio_button_off</i>
      </div>

      <div class="SMTPEmailContainer" (click)="ShowB2BRestrictions = false; ShowShippingInfo = false; ShowBillingInfo = false; ShowAgentsInfo = false; ShowProfitSettings = false; ShowProcessingSettings = true; GetPartnerProcessingSettings();">
        <span>{{'ProcessingSettings' | translate}}</span>
        <i class="material-icons" *ngIf="ShowProcessingSettings == true;">radio_button_checked</i>
        <i class="material-icons" *ngIf="ShowProcessingSettings == false;" style="color: #000;">radio_button_off</i>
      </div>

      <div class="SMTPEmailContainer" (click)="ShowB2BRestrictions = true; ShowShippingInfo = false; ShowBillingInfo = false; ShowAgentsInfo = false; ShowProfitSettings = false; ShowProcessingSettings = false; GetPartnerB2BRestictions(); GetPartnerB2BSettings();">
        <span>{{'B2BSettingsAndRestrictions' | translate}}</span>
        <i class="material-icons" *ngIf="ShowB2BRestrictions == true;">radio_button_checked</i>
        <i class="material-icons" *ngIf="ShowB2BRestrictions == false;" style="color: #000;">radio_button_off</i>
      </div>

      <div *ngIf="ShowBillingInfo" class="fullWidth">
        <div class="TwoThirdsColumn" style="width: 50%;">

          <div class="ColumnTitle">
            <i class="material-icons">radio_button_checked</i>
            {{'GeneralInformation' | translate}}
          </div>
  
          <mat-form-field appearance="outline" class="ProductPropertyTextBox">
            <mat-label>{{ 'Name' | translate }}*</mat-label>
            <input matInput placeholder="{{ 'Name' | translate }}*" autocomplete="off" [(ngModel)]="this.Partner.Name">
          </mat-form-field>
  
          <mat-form-field appearance="outline" class="ProductPropertyTextBox">
            <mat-label>{{ 'VAT' | translate }}*</mat-label>
            <input matInput placeholder="{{ 'VAT' | translate }}*" autocomplete="off" [(ngModel)]="this.Partner.VAT">
          </mat-form-field>
  
          <div class="ProductPropertyTextBox" style="margin-bottom: 20px;">
            <mat-slide-toggle [(ngModel)]="this.Partner.TaxPayer">{{'TaxPayer' | translate}}</mat-slide-toggle>
          </div>
  
          <div class="ProductPropertyTextBox" style="margin-bottom: 20px;">
            <button mat-raised-button class="EUVATVIESButton" (click)="GetPartnerEUData(this.Partner);">
              {{'VerifyEUVATVIES' | translate}}
              <i class="material-icons VatViesIcon" *ngIf="this.Partner.EUVATVerified"  matTooltip="{{ 'EUVATVerifiedDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>verified_user</i>
              <i class="material-icons VatViesIcon" *ngIf="!this.Partner.EUVATVerified" style="color: red;">verified_user</i>
            </button>
          </div>
  
          <mat-form-field appearance="outline" class="ProductPropertyTextBox">
            <mat-label>{{ 'UPN' | translate }}*</mat-label>
            <input matInput placeholder="{{ 'UPN' | translate }}*" autocomplete="off" [(ngModel)]="this.Partner.UPN">
          </mat-form-field>
  
          <mat-form-field appearance="outline" class="ProductPropertyTextBox">
            <mat-label>{{ 'COCRegNumber' | translate }}*</mat-label>
            <input matInput placeholder="{{ 'COCRegNumber' | translate }}*" autocomplete="off" [(ngModel)]="this.Partner.COCRegNumber">
          </mat-form-field>
  
          <mat-form-field appearance="outline" class="ProductPropertyTextBox">
            <mat-label>{{ 'EventRegister' | translate }}*</mat-label>
            <input disabled="true" matInput placeholder="{{ 'EventRegister' | translate }}*" autocomplete="off" [(ngModel)]="this.Partner.RegisteredUI">
          </mat-form-field>
       
          <div class="ColumnTitle">
            <i class="material-icons">location_on</i>
            {{'BillingAddress' | translate}}
          </div>
  
          <mat-form-field appearance="outline"class="ProductPropertyTextBox">
            <mat-label>{{ 'Country' | translate }}</mat-label>
            <mat-select name="Country" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Partner.BillingAddress.Country">
              <mat-option *ngFor="let c of this.Countries" [value]="c">
                {{c.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
  
          <mat-form-field appearance="outline" class="ProductPropertyTextBox">
            <mat-label>{{ 'StateProvince' | translate }}*</mat-label>
            <input matInput placeholder="{{ 'StateProvince' | translate }}*" autocomplete="off" [(ngModel)]="this.Partner.BillingAddress.StateProvince">
          </mat-form-field>
  
          <mat-form-field appearance="outline" class="ProductPropertyTextBox">
            <mat-label>{{ 'City' | translate }}*</mat-label>
            <input matInput placeholder="{{ 'City' | translate }}*" autocomplete="off" [(ngModel)]="this.Partner.BillingAddress.City">
          </mat-form-field>
  
          <mat-form-field appearance="outline" class="ProductPropertyTextBox">
            <mat-label>{{ 'Address' | translate }}*</mat-label>
            <input matInput placeholder="{{ 'Address' | translate }}*" autocomplete="off" [(ngModel)]="this.Partner.BillingAddress.AddressLine">
          </mat-form-field>
  
          <mat-form-field appearance="outline" class="ProductPropertyTextBox">
            <mat-label>{{ 'ZipCode' | translate }}*</mat-label>
            <input matInput placeholder="{{ 'ZipCode' | translate }}*" autocomplete="off" [(ngModel)]="this.Partner.BillingAddress.ZipCode">
          </mat-form-field>   
        </div>
        <div class="OneThirdColumn" style="width: 50%;">
          <div class="ColumnTitle">
            <i class="material-icons">attach_money</i>
            {{'Partners.PartnerWindow.Bank' | translate}}
          </div>
  
          <mat-form-field appearance="outline"class="ProductPropertyTextBox">
            <mat-label>{{ 'Partners.PartnerWindow.Bank' | translate }}</mat-label>
            <mat-select name="Partners.PartnerWindow.Bank" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Partner.Bank">
              <mat-option *ngFor="let b of this.Banks" [value]="b" (click)="SwitchPartnerBank(b);">
                {{b.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
  
          <mat-form-field appearance="outline" class="ProductPropertyTextBox">
            <mat-label>{{ 'Partners.PartnerWindow.Bank' | translate }}*</mat-label>
            <input disabled="true" matInput placeholder="{{ 'Partners.PartnerWindow.Bank' | translate }}*" autocomplete="off" [(ngModel)]="this.Partner.Bank.Name">
          </mat-form-field> 
  
          <mat-form-field appearance="outline" class="ProductPropertyTextBox">
            <mat-label>{{ 'Swift' | translate }}*</mat-label>
            <input disabled="true" matInput placeholder="{{ 'Swift' | translate }}*" autocomplete="off" [(ngModel)]="this.Partner.Bank.Swift">
          </mat-form-field> 
  
          <mat-form-field appearance="outline" class="ProductPropertyTextBox">
            <mat-label>{{ 'Partners.PartnerWindow.BankAccountNumber' | translate }}*</mat-label>
            <input matInput placeholder="{{ 'Partners.PartnerWindow.BankAccountNumber' | translate }}*" autocomplete="off" [(ngModel)]="this.Partner.Bank.BankAccount">
          </mat-form-field> 
  
          <div class="ColumnTitle" style="margin-top: 45px;margin-bottom: 20px;">
            <i class="material-icons">account_circle</i>
            {{'Partners.PartnerWindow.ContactInfo' | translate}}
          </div>
  
          <mat-form-field appearance="outline" class="ProductPropertyTextBox">
            <mat-label>Email</mat-label>
            <input matInput placeholder="Email" autocomplete="off" [(ngModel)]="this.Partner.ContactInfo.Email">
          </mat-form-field> 
  
          <mat-form-field appearance="outline" class="ProductPropertyTextBox">
            <mat-label>{{ 'Partners.PartnerWindow.ContactInfo' | translate }}*</mat-label>
            <input matInput placeholder="{{ 'Partners.PartnerWindow.Name' | translate }}*" autocomplete="off" [(ngModel)]="this.Partner.ContactInfo.Name">
          </mat-form-field> 
  
          <mat-form-field appearance="outline" class="ProductPropertyTextBox">
            <mat-label>{{ 'Login.Phone' | translate }}*</mat-label>
            <input matInput placeholder="{{ 'Login.Phone' | translate }}*" autocomplete="off" [(ngModel)]="this.Partner.ContactInfo.Phone">
          </mat-form-field> 
  
        </div>
      </div>

      <div *ngIf="ShowShippingInfo" class="fullWidth" style="height: auto;float:left;padding-left: 15px;padding-top: 15px;padding-bottom: 50px;">
        <div class="ColumnTitle">
          <i class="material-icons">flight</i>
          {{'ShippingAddresses' | translate}}
        </div>

        <div class="fullWidth">
          <button mat-raised-button color="primary" class="AddNewProductButton" style="margin-left: 0px;" (click)="GenerateInitialShippingAddress();">
            <i class="material-icons">add</i>
            {{'GenerateInitialShippingAddress' | translate}}
          </button>

          <mat-form-field appearance="outline"class="ProductPropertyTextBox" *ngIf="this.Partner.ShippingAddresses?.length > 0;" style="margin-top: 25px; width: 95%;">
            <mat-label>{{ 'ShippingAddresses' | translate }}</mat-label>
            <mat-select name="ShippingAddresses" [compareWith]="this.parent.compareFn" [(ngModel)]="this.CurrentShippingAddress">
              <mat-option *ngFor="let a of this.Partner.ShippingAddresses" [value]="a">
                {{a.Country.Name}} {{a.City}} {{a.AddressLine}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="halfWidth" *ngIf="this.Partner.ShippingAddresses?.length > 0;" style="margin-top:20px;">

          <div class="ColumnTitle" style="margin-bottom: 20px;">
            <i class="material-icons">edit_location</i>
            {{'AddressDetails' | translate}}
          </div>

          <div class="ProductPropertyTextBox" style="margin-bottom: 20px;">
            <mat-slide-toggle [(ngModel)]="this.CurrentShippingAddress.ActiveAddress">
              <span *ngIf="this.CurrentShippingAddress.ActiveAddress == true;">{{'ActiveAddress' | translate}}</span>
              <span *ngIf="this.CurrentShippingAddress.ActiveAddress != true;">{{'DisabledAddress' | translate}}</span>
            </mat-slide-toggle>
          </div>

          <mat-form-field appearance="outline"class="ProductPropertyTextBox">
            <mat-label>{{ 'Country' | translate }}</mat-label>
            <mat-select name="ShippingAddresses" [compareWith]="this.parent.compareFn" [(ngModel)]="this.CurrentShippingAddress.Country">
              <mat-option *ngFor="let c of this.Countries" [value]="c">
                {{c.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="ProductPropertyTextBox">
            <mat-label>{{ 'StateProvince' | translate }}*</mat-label>
            <input matInput placeholder="{{ 'StateProvince' | translate }}*" autocomplete="off" [(ngModel)]="this.CurrentShippingAddress.State">
          </mat-form-field> 

          <mat-form-field appearance="outline" class="ProductPropertyTextBox">
            <mat-label>{{ 'Partners.PartnerWindow.City' | translate }}*</mat-label>
            <input matInput placeholder="{{ 'Partners.PartnerWindow.City' | translate }}*" autocomplete="off" [(ngModel)]="this.CurrentShippingAddress.City">
          </mat-form-field> 

          <mat-form-field appearance="outline" class="ProductPropertyTextBox">
            <mat-label>{{ 'Partners.PartnerWindow.AddressLine' | translate }}*</mat-label>
            <input matInput placeholder="{{ 'Partners.PartnerWindow.AddressLine' | translate }}*" autocomplete="off" [(ngModel)]="this.CurrentShippingAddress.AddressLine">
          </mat-form-field> 

          <mat-form-field appearance="outline" class="ProductPropertyTextBox">
            <mat-label>{{ 'ZipCode' | translate }}*</mat-label>
            <input matInput placeholder="{{ 'ZipCode' | translate }}*" autocomplete="off" [(ngModel)]="this.CurrentShippingAddress.ZipCode">
          </mat-form-field> 

          <div class="ProductPropertyTextBox" style="margin-bottom: 20px;">
            <mat-slide-toggle [(ngModel)]="this.CurrentShippingAddress.IsSelected">{{'MainAddress' | translate}}</mat-slide-toggle>
          </div>

          <button mat-raised-button color="warn" class="DeleteAddressButton" style="margin-left: 0px;" (click)="ShowPartnerAddressDeleteMessage = true;">
            <i class="material-icons">close</i>
            {{'DeleteButton' | translate}}
          </button>

        </div>

        <div class="halfWidth" *ngIf="this.Partner.ShippingAddresses?.length > 0;" style="margin-top:20px;">
          <div class="ColumnTitle" style="margin-bottom: 62px;">
            <i class="material-icons">account_circle</i>
            {{'Partners.PartnerWindow.ContactInfo' | translate}}
          </div>

          <mat-form-field appearance="outline" class="ProductPropertyTextBox">
            <mat-label>{{ 'Partners.PartnerWindow.ContactInfo' | translate }}*</mat-label>
            <input matInput placeholder="{{ 'Partners.PartnerWindow.ContactInfo' | translate }}*" autocomplete="off" [(ngModel)]="this.CurrentShippingAddress.ContactPerson">
          </mat-form-field> 

          <mat-form-field appearance="outline" class="ProductPropertyTextBox">
            <mat-label>{{ 'Company' | translate }}*</mat-label>
            <input matInput placeholder="{{ 'Company' | translate }}*" autocomplete="off" [(ngModel)]="this.CurrentShippingAddress.ContactCompany">
          </mat-form-field> 

          <mat-form-field appearance="outline" class="ProductPropertyTextBox">
            <mat-label>{{ 'Email' | translate }}*</mat-label>
            <input matInput placeholder="{{ 'Email' | translate }}*" autocomplete="off" [(ngModel)]="this.CurrentShippingAddress.Email">
          </mat-form-field> 

          <mat-form-field appearance="outline" class="ProductPropertyTextBox">
            <mat-label>{{ 'Login.Phone' | translate }}*</mat-label>
            <input matInput placeholder="{{ 'Login.Phone' | translate }}*" autocomplete="off" [(ngModel)]="this.CurrentShippingAddress.Phone">
          </mat-form-field> 

          <button mat-raised-button color="primary" class="AddNewProductButton" style="margin-left: 0px;" (click)="AddUpdateShippingAddress(this.CurrentShippingAddress, this.Partner.ID);">
            <i class="material-icons">save_alt</i>
            {{'SaveButton' | translate}}
          </button>
        </div>
      </div>

      <div *ngIf="ShowAgentsInfo" class="fullWidth" style="height: auto;float:left;padding-left: 15px;padding-top: 15px;padding-bottom: 50px;">
        <div class="ColumnTitle">
          <i class="material-icons">flight</i>
          {{'AgentsInfo' | translate}}
        </div>

        <mat-form-field appearance="outline"class="ProductPropertyTextBox" *ngIf="this.PartnerAgents?.length > 0;" style="margin-top: 25px; width: 95%;">
          <mat-label>{{ 'Agents' | translate }}</mat-label>
          <mat-select name="PartnerAgents" [compareWith]="this.parent.compareFn" [(ngModel)]="this.PartnerAgent">
            <mat-option *ngFor="let p of this.PartnerAgents" [value]="p">
              {{p.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="fullWidth">
          <button mat-raised-button color="primary" class="AddNewProductButton" style="margin-left: 0px;" (click)="InitializePartnerAgent(this.Partner.ID);">
            <i class="material-icons">add</i>
            {{'AddNewAgent' | translate}}
          </button>

         <div *ngIf="this.PartnerAgent != null;">
          <mat-form-field appearance="outline"class="ProductPropertyTextBox" *ngIf="this.ShippingAddresses?.length > 0;" style="margin-top: 25px; width: 95%;">
            <mat-label>{{ 'ShippingAddresses' | translate }}</mat-label>
            <mat-select name="PartnerAgentAllocatedShippingAddress" [compareWith]="this.parent.compareFn" [(ngModel)]="this.PartnerAgent.AllocatedShippingAddress">
              <mat-option *ngFor="let a of this.ShippingAddresses" [value]="a">
                {{a.Country.Name}} {{a.City}} {{a.AddressLine}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div class="halfWidth">
            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
              <mat-label>{{ 'Name' | translate }}*</mat-label>
              <input matInput placeholder="{{ 'Name' | translate }}*" autocomplete="off" [(ngModel)]="this.PartnerAgent.Name">
            </mat-form-field> 

            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
              <mat-label>{{ 'Phone' | translate }}*</mat-label>
              <input matInput placeholder="{{ 'Phone' | translate }}*" autocomplete="off" [(ngModel)]="this.PartnerAgent.Phone">
            </mat-form-field> 

            <mat-form-field appearance="outline" class="ProductPropertyTextBox">
              <mat-label>{{ 'Email' | translate }}*</mat-label>
              <input matInput placeholder="{{ 'Email' | translate }}*" autocomplete="off" [(ngModel)]="this.PartnerAgent.Email">
            </mat-form-field> 
         
            <button mat-raised-button color="warn" class="DeleteAddressButton" style="margin-left: 0px;" (click)="ShowPartnerAgentDeleteMessage = true;">
              <i class="material-icons">close</i>
              {{'DeleteButton' | translate}}
            </button>

          </div>

          <div class="halfWidth">
            <mat-form-field appearance="outline"class="ProductPropertyTextBox" *ngIf="this.Departments?.length > 0;">
              <mat-label>{{ 'Department' | translate }}</mat-label>
              <mat-select name="AgentsDepartments" [compareWith]="this.parent.compareFn" [(ngModel)]="this.PartnerAgent.Department">
                <mat-option *ngFor="let d of this.Departments" [value]="d">
                  {{d.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <button mat-raised-button color="primary" class="AddNewProductButton" style="margin-left: 0px;" *ngIf="PartnerAgent != null;" (click)="AddUpdatePartnerAgent();">
              <i class="material-icons">save_alt</i>
              {{'SaveButton' | translate}}
            </button>
          </div>
         </div>
        </div>
      </div>

      <div *ngIf="ShowProfitSettings" class="fullWidth" style="height: auto;float:left;padding-left: 15px;padding-top: 15px;padding-bottom: 50px;">
        <div class="ColumnTitle">
          <i class="material-icons" style=" font-size: 30px;">monetization_on</i>
          {{'ProfitSettings' | translate}}
        </div>

        <div class="ColumnTitle">
          <i class="material-icons" style="color: #00aeef; font-size: 30px;" matTooltip="{{ 'ProfitSettingsDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>info</i>
          <span matTooltip="{{ 'ProfitSettingsDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>Important</span>
        </div>

        <div class="fullWidth">

          <div class="ProfitSettingsTable">
            <button mat-raised-button color="primary" class="AddNewProfitButton" (click)="OpenNewProfitSettings();">
              <i class="material-icons">add</i>
              <span>{{'AddNewProfitSettings' | translate}}</span>
            </button>
          </div>

          <div class="ProfitSettingsTable">
            <div class="ProfitSettingsRow ProfitSettingsHeadder">
              <div class="ProfitSettingsCol" style="width: 5%;">
                <span>#</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 20%;">
                <span>{{'Client' | translate}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 15%;">
                <span>{{'DiscountGroup' | translate}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 15%;">
                <span>{{'ImportConfiguration' | translate}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 15%;">
                <span>{{'Brand' | translate}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 15%;">
                <span>{{'Percentage' | translate}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 10%;">
                <span>{{'Profit' | translate}}</span>
              </div>

              <div class="ProfitSettingsCol" style="width: 5%;">
                <span>{{'Actions' | translate}}</span>
              </div>
            </div>
  
            <div class="ProfitSettingsRow" *ngFor="let ps of this.Partner?.PartnerProfitSettings; let i=index;">
              <div class="ProfitSettingsCol" style="width: 5%;" (click)="EditProfitSettings(ps);">
                <span>{{i + 1}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 20%;" (click)="EditProfitSettings(ps);">
                <span *ngIf="ps.PartnerName != null && ps.PartnerName?.length > 0;">{{ps.PartnerName}}</span>
                <span *ngIf="ps.PartnerName == null || ps.PartnerName?.length == 0;">-----</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 15%;" (click)="EditProfitSettings(ps);">
                <span *ngIf="ps.DiscountGroup != null;">{{ps.DiscountGroup?.GroupName}} </span>
                <span *ngIf="ps.DiscountGroup != null;">({{ps.DiscountGroup?.DiscountValue}}%)</span>
                <span *ngIf="ps.DiscountGroup == null;">-----</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 15%;" (click)="EditProfitSettings(ps);">
                <span *ngIf="ps.ImportConfiguration != null;">{{ps.ImportConfiguration?.Name}}</span>
                <span *ngIf="ps.ImportConfiguration == null;">-----</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 15%;" (click)="EditProfitSettings(ps);">
                <span *ngIf="ps.Brand != null;">{{ps.Brand?.Name}}</span>
                <span *ngIf="ps.Brand == null;">-----</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 15%;" (click)="EditProfitSettings(ps);">
                <span *ngIf="ps.Percentage != null;">{{ps.Percentage}}% {{ps.PercentageImpact?.Name}}</span>
                <span *ngIf="ps.Percentage == null;">-----</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 10%;" (click)="EditProfitSettings(ps);">
                <span *ngIf="ps.PercentageImpact != null;">{{ps.PercentageImpact?.PercentageProfitMargin}}%</span>
                <span *ngIf="ps.PercentageImpact == null;">-----</span>
              </div>

              <div class="ProfitSettingsCol" style="width: 5%;" (click)="CopyProfitSettingsUI(ps);">
                <i class="material-icons">content_copy</i>
              </div>
            </div>
  
          </div>
        </div>
       
      </div>

      <div *ngIf="ShowProcessingSettings" class="fullWidth" style="height: auto;float:left;padding-left: 15px;padding-top: 15px;padding-bottom: 50px;">
        <div class="ColumnTitle">
          <i class="material-icons" style="color: #00aeef; font-size: 30px;" matTooltip="{{ 'ProcessingSettingsDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>info</i>
          <span>{{'ProcessingSettings' | translate}}</span>
        </div>

        <div class="fullWidth">
          <div class="CheckboxProperty" style="margin-bottom: 20px;">
            <mat-slide-toggle [(ngModel)]="this.Partner.ProcessingSettings.NotifiesWithAttachments" matTooltip="{{ 'NotifiesWithAttachmentsDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>{{'NotifiesWithAttachments' | translate}}</mat-slide-toggle>
          </div>

          <div class="CheckboxProperty" style="margin-bottom: 20px;">
            <mat-slide-toggle [(ngModel)]="this.Partner.ProcessingSettings.AutoPrinting" matTooltip="{{ 'AutoPrintingDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>{{'AutoPrinting' | translate}}</mat-slide-toggle>
          </div>

          <div class="CheckboxProperty" style="margin-bottom: 20px;">
            <mat-slide-toggle [(ngModel)]="this.Partner.ProcessingSettings.AllocateAutomaticShippingCost" matTooltip="{{ 'AllocateAutomaticShippingCostDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>{{'AllocateAutomaticShippingCost' | translate}}</mat-slide-toggle>
          </div>

          <div class="CheckboxProperty" style="margin-bottom: 20px;">
            <mat-slide-toggle [(ngModel)]="this.Partner.ProcessingSettings.GenerateInvoice" matTooltip="{{ 'GenerateInvoiceDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>{{'GenerateInvoice' | translate}}</mat-slide-toggle>
          </div>

          <div class="CheckboxProperty" style="margin-bottom: 20px;">
            <mat-slide-toggle [(ngModel)]="this.Partner.ProcessingSettings.GenerateTrackingLabel" matTooltip="{{ 'GenerateTrackingLabelDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>{{'GenerateTrackingLabel' | translate}}</mat-slide-toggle>
          </div>

          <div class="CheckboxProperty" style="margin-bottom: 20px;">
            <mat-slide-toggle [(ngModel)]="this.Partner.ProcessingSettings.SeparateOrderInvoices" matTooltip="{{ 'SeparateOrderInvoicesDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>{{'SeparateOrderInvoices' | translate}}</mat-slide-toggle>
          </div>

          <div class="CheckboxProperty" style="margin-bottom: 20px;">
            <mat-slide-toggle [(ngModel)]="this.Partner.ProcessingSettings.SplitShippingCostOnAllInvoices" matTooltip="{{ 'SplitShippingCostOnAllInvoicesDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>{{'SplitShippingCostOnAllInvoices' | translate}}</mat-slide-toggle>
          </div>

          <div class="CheckboxProperty" style="margin-bottom: 20px;">
            <mat-slide-toggle [(ngModel)]="this.Partner.ProcessingSettings.GenerateQWCertificate" matTooltip="{{ 'GenerateQWCertificateDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>{{'GenerateQWCertificate' | translate}}</mat-slide-toggle>
          </div>

          <div class="CheckboxProperty" style="margin-bottom: 20px;">
            <mat-slide-toggle [(ngModel)]="this.Partner.ProcessingSettings.PrintOnlyDeliveryNote" matTooltip="{{ 'PrintOnlyDeliveryNoteDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>{{'PrintOnlyDeliveryNote' | translate}}</mat-slide-toggle>
          </div>

          <div class="CheckboxProperty" style="margin-bottom: 20px;">
            <mat-slide-toggle [(ngModel)]="this.Partner.ProcessingSettings.SendInvoiceOnlyToAccountingDepartment" matTooltip="{{ 'SendInvoiceOnlyToAccountingDepartmentDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>{{'SendInvoiceOnlyToAccountingDepartment' | translate}}</mat-slide-toggle>
          </div>

          <mat-form-field class="ProcessingSettingsCurrency" appearance="outline" matTooltip="{{ 'ProcessingSettingsCurrencyDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>
            <mat-label>{{ 'ProcessingSettingsCurrency' | translate }}</mat-label>
            <mat-select name="currency" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Partner.ProcessingSettings.Currency">
              <mat-option *ngFor="let c of this.Currencies" [value]="c">
                {{c.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="ProcessingSettingsCurrency" appearance="outline">
            <mat-label>{{ 'DecimalPercision' | translate }}</mat-label>
            <mat-select name="DecimalPrecision" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Partner.ProcessingSettings.DecimalPrecision">
              <mat-option *ngFor="let d of this.DecimalPrecisions" [value]="d">
                {{d.Meaning}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div class="ProcessingSettingsCurrency">
            <mat-form-field appearance="outline" class="example-full-width fullWidthContainer">
              <mat-label>{{'OrderRank' | translate}}</mat-label>
              <input matInput type="number" [(ngModel)]="this.Partner.ProcessingSettings.UnpaidTolleranceDays" min="0" max="100" step="1">
            </mat-form-field>
          </div>

          <div style="width: 100%;float: left;height: 40px;">
            <div class="CheckboxProperty" style="margin-bottom: 20px;">
              <mat-slide-toggle [(ngModel)]="this.Partner.ProcessingSettings.SellThroughPartnerCompany" matTooltip="{{ 'SellingPartnerCompanyDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>{{'SellingPartnerCompany' | translate}}</mat-slide-toggle>
            </div>
          </div>

          <div style="width: 100%;float: left;margin-bottom: 25px;" *ngIf="this.Partner.ProcessingSettings.SellThroughPartnerCompany == true;">
            <mat-form-field class="ProcessingSettingsCurrency" appearance="outline">
              <mat-label>{{ 'ChooseSellingPartnerCompany' | translate }}</mat-label>
              <mat-select name="PartnerCompany" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Partner.ProcessingSettings.PartnerCompany">
                <mat-option *ngFor="let c of this.Companies" [value]="c">
                  {{c.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <button style="color: #fff;background: #020044;margin-top: 50px;" mat-raised-button class="SaveProcessingSettingsButton" (click)="AddUpdatePartnerProcessingSettings();">
            <i class="material-icons">save_alt</i>
            {{'SaveProcessingSettings' | translate}}
          </button>

        </div>
      </div>

      <div *ngIf="ShowB2BRestrictions" class="fullWidth" style="height: auto;float:left;padding-left: 15px;padding-top: 15px;padding-bottom: 50px;">
        <div class="ColumnTitle">
          <i class="material-icons" style="color: #00aeef; font-size: 30px;" matTooltip="{{ 'B2BRestrictionsDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>info</i>
          <span>{{'B2BSettingsAndRestrictions' | translate}}</span>
        </div>

        <div class="fullWidthSubtitle">
          {{'B2BSettings' | translate}}
        </div>

        <mat-form-field class="ProcessingSettingsCurrency" appearance="outline">
          <mat-label>{{ 'B2BPartnerCategory' | translate }}</mat-label>
          <mat-select name="DecimalPrecision" [compareWith]="this.parent.compareFn" [(ngModel)]="this.Partner.B2BSettings.B2BPartnerCategory">
            <mat-option *ngFor="let c of this.B2BPartnerCategories" [value]="c">
              <span matTooltip="{{c.Description}}" matTooltipClass='neutral-tool-tip-management'>{{c.Name}}</span>
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="fullWidth" *ngIf="this.Partner.B2BSettings != null;" style="margin-top: 20px;">
          <mat-slide-toggle class="B2BSettingsToggle" [(ngModel)]="this.Partner.B2BSettings.PrioritizePriceHistory">{{'ClientHistoryPricePriority' | translate}}</mat-slide-toggle>
          <mat-slide-toggle class="B2BSettingsToggle" [(ngModel)]="this.Partner.B2BSettings.CanDownloadPriceLists">{{'CanDownloadPriceLists' | translate}}</mat-slide-toggle>
          <mat-slide-toggle class="B2BSettingsToggle" [(ngModel)]="this.Partner.B2BSettings.Blocked">{{'Blocked' | translate}}</mat-slide-toggle>

          <div class="fullWidth">
            <button (click)="AddUpdatePartnerB2BSettings(this.Partner);" style="color: #fff;background: #020044;margin-top: 10px;width: 15%; height: 40px; margin-bottom: 10px;" mat-raised-button class="SaveProcessingSettingsButton">
              <i class="material-icons">add</i>
              {{'SaveButton' | translate}}
            </button>
          </div>
        </div>

        <div class="fullWidth" style="margin-top: 20px; margin-bottom: 20px;">
          <div class="ProfitSettingsTable">
            <div class="ProfitSettingsRow ProfitSettingsHeadder">
              <div class="ProfitSettingsCol" style="width: 5%;">
                <span>#</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 20%;">
                <span style="font-size: 10px;">{{'Client' | translate}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 7.5%;">
                <span>{{'YearsBehind' | translate}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 7.5%;">
                <span>{{'YearsBehindTargetYear' | translate}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 5%;">
                <span>{{'ExtraAddedPercentageValue' | translate}}</span>
              </div>

              <div class="ProfitSettingsCol" style="width: 20%;">
                <span>{{'Brand' | translate}}</span>
              </div>

              <div class="ProfitSettingsCol" style="width: 10%;">
                <span>{{'OnlyPerosnalHistory' | translate}}</span>
              </div>

              <div class="ProfitSettingsCol" style="width: 10%;">
                <span>{{'CompareHistoryPriceWithListPrice' | translate}}</span>
              </div>

              <div class="ProfitSettingsCol" style="width: 15%;">
                <span>{{'Actions' | translate}}</span>
              </div>
            </div>
  
            <div class="ProfitSettingsRow" *ngFor="let setting of this.Partner?.B2BSettings?.YearSettings; let i=index;">
              <div class="ProfitSettingsCol" style="width: 5%;">
                <span>{{i + 1}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 20%;">
                <span style="font-size: 10px;">{{this.Partner.Name}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 7.5%;">
                <mat-form-field class="example-full-width" appearance="outline" style="width: 100%;">
                  <mat-label>{{'YearsBehind' | translate}}</mat-label>
                  <input (keypress)="restrictNonNumericInput($event)" (change)="onYearsBehindChange($event)" [(ngModel)]="setting.YearsBehind" matInput #postalCode maxlength="5">
                </mat-form-field>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 7.5%;">
                <span>{{setting.YearsBehindTargetYear}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 5%;" >
                <mat-form-field class="example-full-width" appearance="outline" style="width: 100%;">
                  <mat-label>{{'ExtraAddedPercentageValue' | translate}}</mat-label>
                  <input [(ngModel)]="this.setting.ExtraAddedPercentageValue" matInput #postalCode maxlength="5">
                </mat-form-field>
              </div>

              <div class="ProfitSettingsCol" style="width: 20%;" (click)="this.CurrentYearSetting = setting; OpenYearSettingsBrandChange();">
                <span *ngIf="setting?.Brand?.ID > 0">{{setting?.Brand?.Name}}</span>
                <span *ngIf="!(setting?.Brand?.ID > 0)">-------------</span>
              </div>

              <div class="ProfitSettingsCol" style="width: 10%;" >
                <span>
                  <mat-slide-toggle class="B2BSettingsToggle" [(ngModel)]="setting.OnlyPerosnalHistory"></mat-slide-toggle>
                </span>
              </div>

              <div class="ProfitSettingsCol" style="width: 10%;" >
                <span>
                  <mat-slide-toggle class="B2BSettingsToggle" [(ngModel)]="setting.CompareHistoryPriceWithListPrice"></mat-slide-toggle>
                </span>
              </div>
          
              <div class="ProfitSettingsCol" style="width: 15%;">
                <i class="material-icons RestrictionIcon" style="color: #32aa3a;" (click)="AddUpdateHistoryYearSetting(setting);">check</i>
                <i class="material-icons RestrictionIcon" (click)="PrepareYearSettingsDelete(setting);">close</i>
              </div>
            </div>

            <div class="ProfitSettingsRow">
              <div class="ProfitSettingsCol" style="width: 5%;">
                <div class="AddYearSettingsButton" (click)="InitializeNewYearsSettings();" *ngIf="this.NewYearSettings?.DBID != 0;">
                  <i class="material-icons">add</i>
                </div>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 20%;" *ngIf="this.NewYearSettings?.DBID == 0;">
                <span style="font-size: 10px;">{{this.Partner.Name}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 7.5%;" *ngIf="this.NewYearSettings?.DBID == 0;">
                <mat-form-field class="example-full-width" appearance="outline" style="width: 100%;">
                  <mat-label>{{'YearsBehind' | translate}}</mat-label>
                  <input (keypress)="restrictNonNumericInput($event)" (change)="onYearsBehindChange($event)" [(ngModel)]="this.NewYearSettings.YearsBehind" matInput #postalCode maxlength="5">
                </mat-form-field>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 7.5%;" *ngIf="this.NewYearSettings?.DBID == 0;">
                <span>{{this.NewYearSettings.YearsBehindTargetYear}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 5%;" *ngIf="this.NewYearSettings?.DBID == 0;">
                <mat-form-field class="example-full-width" appearance="outline" style="width: 100%;">
                  <mat-label>{{'ExtraAddedPercentageValue' | translate}}</mat-label>
                  <input [(ngModel)]="this.NewYearSettings.ExtraAddedPercentageValue" matInput #postalCode maxlength="5">
                </mat-form-field>
              </div>

              <div class="ProfitSettingsCol" style="width: 20%;" *ngIf="this.NewYearSettings?.DBID == 0;" (click)="OpenNewYearSettingsBrandChange();">
                <span *ngIf="this.NewYearSettings?.Brand?.ID > 0">{{this.NewYearSettings?.Brand?.Name}}</span>
                <span *ngIf="!(this.NewYearSettings?.Brand?.ID > 0)">-------------</span>
              </div>

              <div class="ProfitSettingsCol" style="width: 10%;" *ngIf="this.NewYearSettings?.DBID == 0;">
                <span>
                  <mat-slide-toggle class="B2BSettingsToggle" [(ngModel)]="NewYearSettings.OnlyPerosnalHistory"></mat-slide-toggle>
                </span>
              </div>

              <div class="ProfitSettingsCol" style="width: 10%;" *ngIf="this.NewYearSettings?.DBID == 0;">
                <span>
                  <mat-slide-toggle class="B2BSettingsToggle" [(ngModel)]="NewYearSettings.CompareHistoryPriceWithListPrice"></mat-slide-toggle>
                </span>
              </div>
          
              <div class="ProfitSettingsCol" style="width: 15%;" *ngIf="this.NewYearSettings?.DBID == 0;">
                <i class="material-icons RestrictionIcon" style="color: #32aa3a;" (click)="AddUpdateHistoryYearSetting(this.NewYearSettings);">check</i>
                <i class="material-icons RestrictionIcon" (click)="this.NewYearSettings = null;">close</i>
              </div>
            </div>
  
          </div>
        </div>

        <div class="fullWidthDelimiter"></div>

        <div class="fullWidthSubtitle">
          {{'B2BRestrictions' | translate}}
        </div>

        <div class="fullWidth">
          <button (click)="InitializeNewRestriction(this.Partner);" style="color: #fff;background: #020044;margin-top: 10px;width: 25%; height: 60px; margin-bottom: 10px;" mat-raised-button class="SaveProcessingSettingsButton">
            <i class="material-icons">add</i>
            {{'NewB2BRestrictions' | translate}}
          </button>

          <div class="ProfitSettingsTable">
            <div class="ProfitSettingsRow ProfitSettingsHeadder">
              <div class="ProfitSettingsCol" style="width: 5%;">
                <span>#</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 20%;">
                <span>{{'Client' | translate}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 15%;">
                <span>{{'RestrictionType' | translate}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 15%;">
                <span>{{'ImportConfiguration' | translate}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 20%;">
                <span>{{'Brand' | translate}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 10%;">
                <span>{{'Country' | translate}}</span>
              </div>

              <div class="ProfitSettingsCol" style="width: 15%;">
                <span>{{'Actions' | translate}}</span>
              </div>
            </div>
  
            <div class="ProfitSettingsRow" *ngFor="let res of this.Partner?.B2BRestrictions; let i=index;">
              <div class="ProfitSettingsCol" style="width: 5%;">
                <span>{{i + 1}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 20%;">
                <span>{{this.Partner.Name}}</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 15%;">
                <span>{{res.Type.Name}} </span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 15%;">
                <span *ngIf="res.RestrictedConfiguration != null;">{{res.RestrictedConfiguration?.Name}}</span>
                <span *ngIf="res.RestrictedConfiguration == null;">-----</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 20%;" >
                <span *ngIf="res.RestrictedBrand != null;">{{res.RestrictedBrand?.Name}}</span>
                <span *ngIf="res.RestrictedBrand == null;">-----</span>
              </div>
  
              <div class="ProfitSettingsCol" style="width: 10%;">
                <span *ngIf="res.RestrictedCountry != null;">{{res.RestrictedCountry?.Name}}</span>
                <span *ngIf="res.RestrictedCountry == null;">-----</span>
              </div>

              <div class="ProfitSettingsCol" style="width: 15%;">
                <i class="material-icons RestrictionIcon" (click)="PrepareRestrictionDelete(res);">close</i>
              </div>
            </div>
  
          </div>
        </div>
      </div>

    </div>
    <div class="NewProductContainerCommands">
      <button mat-raised-button color="primary" class="AddNewProductButton" *ngIf="this.Partner.ID == null;" (click)="AddNewPartner(this.Partner);">
        <i class="material-icons">add</i>
        {{'AddNewPartner' | translate}}
      </button>

      <button mat-raised-button color="primary" class="AddNewProductButton" *ngIf="this.Partner.ID?.length > 0;" (click)="UpdatePartner(this.Partner);">
        <i class="material-icons">edit</i>
        {{'ModifyPartner' | translate}}
      </button>
    </div>
  </div>

  <div class="PageContentTitle">
        <div class="PageContentTitleIntro">
            <i class="material-icons">manage_accounts</i>
            <p class="PageContentTitleParagraph">{{'PartnersMenu' | translate}}</p>
        </div>

        <div class="TitleSearchInputContainer">
            <input type="text" class="TitleSearchInput" placeholder="{{'SearchPartners' | translate}}" autocomplete="off" [(ngModel)]="this.Filter.SearchTerm" matInput (ngModelChange)="this.searchTermUpdate.next($event)">
            <i class="material-icons TitleSearchInputContainerSearchIcon">search</i>
            <i class="material-icons TitleSearchInputContainerCloseIcon" *ngIf="this.SearchTerm?.length > 0;" (click)="this.SearchTerm = ''; this.Partners.length = 0;">close</i>
        </div>

        <div class="PageContentTitleCommands">
            <button mat-raised-button color="primary" class="TitleFilterButton" (click)="ShowFilter = !ShowFilter;">
                {{'Filter' | translate}}
                <i class="material-icons">filter_alt</i>
                <span class="ButtonNotification" *ngIf="activeFilters.length > 0;">{{activeFilters.length}}</span>
            </button>

            <button mat-raised-button color="primary" class="TitleFilterButton NewTaskButton" (click)="InitializeNewPartner();">
                {{ 'Partners.AddNewPartner' | translate }}
                <i class="material-icons">add</i>
            </button>

            <div class="ButtonFilterContainer animated fadeIn" *ngIf="ShowFilter == true;">
                <i class="material-icons ButtonFilterContainerCloseIcon" (click)="ShowFilter = false;">close</i>
                <mat-spinner class="smallSpinner" [diameter]="30" *ngIf="this.FilterLoading == true;"></mat-spinner>
                
                <div *ngIf="this.FilterLoading != true;">
                    <div class="ButtonFilterContainerRow">
                        <div class="ButtonFilterContainerOneThirdColumn">
                          <mat-form-field class="ButtonFilterDropDown" appearance="outline">
                            <mat-label>{{'Company' | translate}}</mat-label>
                            <mat-select name="Company" [(ngModel)]="Filter.Company">
                              <mat-option *ngFor="let c of this.Companies;" [value]="c" (click)="AddActiveFilter(c.Name, 'Company');">
                                {{c.Name}}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <div class="ButtonFilterContainerTwoThirdsColumn">
                            <mat-form-field class="ButtonFilterDropDown" appearance="outline">
                                <mat-label>{{'Countries' | translate}}</mat-label>
                                <mat-select name="Countries" [(ngModel)]="Filter.Country">
                                  <mat-option *ngFor="let c of this.Countries;" [value]="c" (click)="AddActiveFilter(c.Name, 'Country');">
                                    {{c.Name}}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                        </div>
                    </div>

                    <div class="ButtonFilterContainerRow" style="padding-left: 3%;height: auto;min-height: 60px;padding-top: 10px;">
                      <div class="ActiveFilter" *ngFor="let a of this.activeFilters;" (click)="RemoveActiveFilter(a.ID, a.Type);">
                        {{a.Name}}
                        <i class="material-icons ActiveFilterIcon">close</i>
                      </div>
                    </div>

                    <div class="ButtonFilterContainerRow" style="margin-bottom: 15px;">
                        <div class="ButtonFilterContainerOneThirdColumn">
                            <button mat-raised-button color="primary" class="ApplyFilterButton" (click)="ShowFilter = false;GetPartnersFiltered();">
                                <i class="material-icons">check</i>
                                {{'ApplyFilter' | translate}}
                            </button>
                        </div>
                        <div class="ButtonFilterContainerTwoThirdsColumn">

                        </div>
                    </div>
                </div>
            </div>
        </div>
  </div>

  <div class="PageContentBody animated fadeIn">
        <div class="PageContentBodyTopCommands">
          <div class="TopLevelPaginator unSelectable">
            <div class="TopLevelPaginatorButton" *ngIf="this.Filter.Pager.PageIndex != 1;" (click)="this.Filter.Pager.PageIndex = this.Filter.Pager.PageIndex - 1; GetPartnersFiltered();">
              <i class="material-icons">chevron_left</i>
            </div>
            <div class="TopLevelPaginatorButton" *ngIf="this.Filter.Pager.PageIndex == 1;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
              <i class="material-icons">chevron_left</i>
            </div>

            <mat-form-field appearance="outline" class="TopLevelPaginatorTextBox">
              <mat-label>{{ 'PageSize' | translate }}*</mat-label>
              <input matInput autocomplete="off" [(ngModel)]="Filter.Pager.PageSize" (change)="this.Filter.Pager.PageIndex = 1; GetPartnersFiltered();">
            </mat-form-field>

            <div class="TopLevelPaginatorButton" *ngIf="this.Filter.Pager.PageIndex != this.Filter.Pager.Pages;" (click)="this.Filter.Pager.PageIndex = this.Filter.Pager.PageIndex + 1; GetPartnersFiltered();;">
              <i class="material-icons">chevron_right</i>
            </div>
            <div class="TopLevelPaginatorButton" *ngIf="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
              <i class="material-icons">chevron_right</i>
            </div>

            <span class="pageInfoSpan">{{this.Partners?.length}} {{'OfWord' | translate}} {{this.Filter.Pager.TotalCount}} {{'PartnersMenu' | translate }} ({{'Page' | translate}}: {{this.Filter.Pager.PageIndex}})</span>
          </div>

          <button mat-raised-button color="primary" class="FilterResultsButton" (click)="GetPartnersFiltered();">
            <i class="material-icons">check</i>
            {{'ApplyFilter' | translate}}
          </button>

          <button mat-raised-button style="margin-left: 2%;" color="primary" class="TitleFilterButton" (click)="ShowGeneratePartnersSearchResultsQuestion();">
            {{ 'GeneratePartnersSearchResults' | translate }}
            <i class="material-icons">search</i>
        </button>
        </div>

        <div class="PageContentBodyElementsContainer">
          <div class="TaskRow TaskHeadderRow">
            <div class="ProductsCol dottedRow" style="width: 5%;text-align:center;">
              #
            </div>
            <div class="ProductsCol" style="width: 20%;">
              {{'Name' | translate}}
            </div>
            <div class="ProductsCol" style="width: 5%;text-align: right;">
              {{'Code' | translate}}
            </div>
            <div class="ProductsCol" style="width: 20%;text-align: center;">
              {{'VAT' | translate}}
            </div>
            <div class="ProductsCol" style="width: 10%;">
              {{'Country' | translate}}
            </div>
            <div class="ProductsCol" style="width: 10%;">
              {{'Partners.PartnerWindow.City' | translate}}
            </div>
            <div class="ProductsCol" style="width: 10%;">
              {{'EventRegister' | translate}}
            </div>
            <div class="ProductsCol" style="width: 10%;">
              {{'EUViesVerified' | translate}}
            </div>
            <div class="ProductsCol" style="width: 10%;text-align:center;">
              {{'Actions' | translate}}
            </div>
          </div>

          <div class="ProductsContainer">
              <div class="ProductRow" *ngFor="let p of this.Partners; let i=index;">
              <div class="ProductsCol dottedRow" style="width: 5%;text-align:center;">
                {{i + 1}}
              </div>
              <div class="ProductsCol" style="width: 20%;">
                {{p.Name}}
              </div>
              <div class="ProductsCol" style="width: 5%;text-align: right;">
                {{p.Code}}
              </div>
              <div class="ProductsCol" style="width: 20%;text-align: center;">
                {{p.VAT}}
              </div>
              <div class="ProductsCol" style="width: 10%;">
                {{p.BillingAddress.Country.Name}}
              </div>
              <div class="ProductsCol" style="width: 10%;">
                {{p.BillingAddress.City}}
              </div>
              <div class="ProductsCol" style="width: 10%;">
                {{p.RegisteredUI}}
              </div>
              <div class="ProductsCol" style="width: 10%;text-align: center;">
                <i class="material-icons VerifiedPartnerMark" *ngIf="p.EUVATVerified" matTooltip="{{ 'EUVATVerifiedDesc' | translate }}" matTooltipClass='neutral-tool-tip-management'>verified_user</i>
              </div>
              <div class="ProductsCol" style="width: 10%;text-align: center;padding-top: 10px;">
                <i class="material-icons actionsArrow unSelectable" [matMenuTriggerFor]="menu">keyboard_arrow_down</i>
                <mat-menu #menu="matMenu">
                 <button mat-menu-item class="ReceptionMenuButton" (click)="InitializeNewPartnerForm(p);">
                     <i class="material-icons">edit</i>
                     <span>{{ 'Receptions.Table.ButtonMenu.modify' | translate }}</span>
                 </button>

                 <button mat-menu-item class="ReceptionMenuButton" (click)="this.Partner = p; this.GetB2BClientOCReadyItemsUX(p);" matTooltip="{{ 'RequestItemsShipmentDescription' | translate}}" matTooltipClass='neutral-tool-tip'>
                  <i class="material-icons">check</i>
                  <span>{{ 'RequestItemsShipment' | translate }}</span>
                 </button>

                 <button mat-menu-item class="ReceptionMenuButton">
                   <i class="material-icons">close</i>
                   <span>{{ 'Delete' | translate }}</span>
                 </button>
                </mat-menu>
              </div>
            </div>
          </div>

        </div>
  </div>
     
  </div>